import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=75047783&"
import script from "./Clubs.vue?vue&type=script&lang=js&"
export * from "./Clubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports